module.exports = __webpack_public_path__ + "static/media/file-zipper-regular.7a1ebacc.svg";